import { createChannel, createEvent } from 'sierra-client/realtime-data/channels/types'
import { z } from 'zod'
export * from 'sierra-client/realtime-data/channels/live-session-data-channel'

export const liveRoomChannel = createChannel('live-room', [
  createEvent('room-settings-updated', z.object({})),
])
